var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgyptian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c3.038 0 5.5 2.686 5.5 6 0 1.934-.84 3.653-2.142 4.75H18a.75.75 0 010 1.5h-5.25V22a.75.75 0 01-1.5 0v-7.75H6a.75.75 0 010-1.5h2.642C7.34 11.653 6.5 9.934 6.5 8c0-3.314 2.462-6 5.5-6zm0 1.5C9.911 3.5 8 5.39 8 8c0 2.61 1.911 4.5 4 4.5s4-1.89 4-4.5c0-2.61-1.911-4.5-4-4.5z",
    fill: "currentColor"
  })));
}
SvgEgyptian.displayName = 'Egyptian';
export default SvgEgyptian;